<template>
    <div id="innovative-features-section" class="pt-7 pb-7">
        <div class="container-fluid">
            <div class="text-default text-center">
                <h2 class="display-3 montserrat-bold text-uppercase mb-3">Innovative <span class="text-danger inline">Features</span></h2>
            </div>
            <div class="container-fluid text-default">
                <div class="row">
                    <div class="col-lg-6 text-right d-none d-lg-block">
                        <div class="parallax" data-speed="0.1" data-initial-offset="-200">
                            <img :src="mobileImage" class="parallax-item" alt="">
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="features-section">
                            <span class="icon-bullet-icon">1</span>
                            <div class="icon-bullet-text-wrapper wide">
                                <div class="icon-bullet-text text-lg">Location-based service</div>
                                <div class="">Schedule services at your current or choice location from available Cutiefy accredited service providers nearby</div>
                            </div>
                        </div>
                        <div class="features-section">
                            <span class="icon-bullet-icon">2</span>
                            <div class="icon-bullet-text-wrapper wide">
                                <div class="icon-bullet-text text-lg">Filter Selection</div>
                                <div class="">Filter your selection based on price range</div>
                            </div>
                        </div>
                        <div class="features-section">
                            <span class="icon-bullet-icon">3</span>
                            <div class="icon-bullet-text-wrapper wide">
                                <div class="icon-bullet-text text-lg">Filter your selection based on price range</div>
                                <div class="">Browse through the service provider’s profile before making the final selection</div>
                            </div>
                        </div>
                        <div class="features-section">
                            <span class="icon-bullet-icon">4</span>
                            <div class="icon-bullet-text-wrapper wide">
                                <div class="icon-bullet-text text-lg">Several payment options</div>
                                <div class="">Cutiefy mobile app accepts debit or credit card payments through PayPal as well as Cash payments.</div>
                            </div>
                        </div>
                        <div class="features-section">
                            <span class="icon-bullet-icon">5</span>
                            <div class="icon-bullet-text-wrapper wide">
                                <div class="icon-bullet-text text-lg">Book in advance</div>
                                <div class="">Choose your preferred date and time within regular business hours</div>
                            </div>
                        </div>
                        <div class="features-section">
                            <span class="icon-bullet-icon">6</span>
                            <div class="icon-bullet-text-wrapper wide">
                                <div class="icon-bullet-text text-lg">Avail of multiple services in one booking</div>
                                <div class="">Book for the whole family or a group of friends under one transaction</div>
                            </div>
                        </div>
                        <div class="features-section">
                            <span class="icon-bullet-icon">7</span>
                            <div class="icon-bullet-text-wrapper wide">
                                <div class="icon-bullet-text text-lg">Choose your preferred beauty expert</div>
                                <div class="">Select from your preferred Service Provider’s roster of available highly-skilled experts</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { resource } from "@utils/network";
export default {
    name: "InnovativeFeaturesSection",
    data: () => ({
        mobileImage: resource('images/mobile-phone.png'),
    })
}
</script>

<style scoped lang="css">
    .features-section {
        margin-top: 30px
    }
    .features-section .icon-bullet-icon {
        font-family: 'Montserrat', sans-serif;
    }
</style>